// add class to 4 and up flex content homepage certs
export const frontpage_cert_arges = () => {  
    var $items = $('.resp-cert-course .col-lg-4')
    $items.each(function(index) {
        if (index >= 3) { 
            $(this).addClass('mobile-hide-this')
        }
    })

}

export const ubermagic = () => {   
    $('.ubermenu-has-submenu-drop').each(function() {
        const originalLink = $(this).children('a')
        if (originalLink.length) {
            originalLink.clone()
                .removeClass()  
                .addClass('dups')  
                .text('')          
                .insertBefore(originalLink) 
        }
    })
}

export const ubermagicclick = () => {   
    $(document).on('click', '.dups', function() {
        $('.ubermenu-submenu').css('opacity', '0')
    })
}

export const disablescrollonburgerclick = () => {   
    var clickCount = 0
    $('.ubermenu-responsive-toggle').click(function() {
        clickCount++ 
        if (clickCount === 1) {
            disableScroll()
        } else if (clickCount === 2) {    
            enableScroll()
            clickCount = 0
        }
    })

    function disableScroll() {
        $('body').css('overflow', 'hidden')
        $(window).on('wheel', preventScroll) 
        console.log("Scroll disabled.")
    }

    function enableScroll() {
        $('body').css('overflow', 'auto')
        $(window).off('wheel', preventScroll) 
        console.log("Scroll enabled.")
    }	
    
    function preventScroll(event) {
        event.preventDefault()
    }
}

export const moveme = () => {
    var screenWidth = $(window).width()

    if (screenWidth < 768) {
        $('.section-stats.visible-medium.visible-small').prependTo('.hero-form')
    } else {
        $('.section-stats.visible-medium.visible-small').appendTo('.section-stats.visible-large')
    }
}

export const handlemoveme = () =>{
    $(window).resize(function() {
        moveme()
    })
}